import React from 'react'
import './style.css'
class BankCardDistinguish extends React.Component {
    render() {
        return(
            <div className='bankcard'>
                <h1>银行卡识别</h1>
            </div>
        )
    }
}
export default BankCardDistinguish